/**
 * TinyToggle —— 深色主題的開關（公版）
 *
 * 🚫 **不要用 reactstrap 的 `<CustomInput type="switch">`** —— Bootstrap 的
 *    custom-switch 在這個深色主題下（尤其是**開啟狀態**）長得很怪，
 *    Brad 2026-09-10 在「額外交收中心 → 特殊規則」的狀態欄實際看到並回報。
 *    樣式本身早就寫在 `adminTheme.switchStyles` 並註明了原因，但只有
 *    `TinyUsers.js` 內部有一份 `Toggle` 包裝、沒有人能重用 —— 所以第二個
 *    需要開關的地方就又退回 CustomInput。抽出來就是為了斷掉這個循環。
 *
 * 有鍵盤操作（Enter / Space）與 `role="switch"`＋`aria-checked`。
 */
import React from "react";
import PropTypes from "prop-types";
import { COLORS, switchStyles } from "constant/adminTheme";

const TinyToggle = ({ on, color = COLORS.success, disabled = false, onClick, title }) => (
  <span
    role="switch"
    aria-checked={on}
    tabIndex={disabled ? -1 : 0}
    title={title}
    onClick={disabled ? undefined : onClick}
    onKeyDown={(e) => {
      if (!disabled && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        onClick();
      }
    }}
    style={{ ...switchStyles.track(on, color), ...(disabled ? switchStyles.disabled : {}) }}
  >
    <span style={switchStyles.knob(on, color)} />
  </span>
);

TinyToggle.propTypes = {
  on: PropTypes.bool,
  /** 開啟時的色（hex）—— 軌道用它的 32% 透明度、圓鈕用實色 */
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default TinyToggle;
